<template>
  <div class="search-base search-container">
    <search-filter-item
      v-if="layout === 'filter'"
      ref="searchFilterItem"
      :label="label"
      @remove="onClickFilterRemove"
    >
      <div class="pt-3">
        <search-nav-company-ids label="" v-model="companies" @input="change"/>
      </div>
    </search-filter-item>
    <search-label-body v-else :label="label" :label-hidden="!label" :columns="gridTemplateColumns">
      <div class="pt-3">
        <search-nav-company-ids label="" v-model="companies" @input="change"/>
      </div>
    </search-label-body>
  </div>
</template>

<script>
import SearchNavCompanyIds from "@/components/nav/SearchNavCompanyIds.vue";
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import SearchFilterItem from "@/views/list/components/base/SearchFilterItem.vue";

export default {
  name: "SearchCompanyIds",
  components: {
    SearchFilterItem,
    SearchNavCompanyIds,
    SearchLabelBody
  },
  props: {
    label: {
      default: "관련부서",
      type: String,
    },
    value: Array,
    setRef: Function,
    options: Object,
  },
  watch: {
    value(value) {
      this.companies = value;
    },
  },
  computed: {
    layout() {
      return this.options && this.options.layout ? this.options.layout : 'default';
    },
    isMobile () {
      return !(this.$store.state.verticalNavMenuWidth === 'default')
    },
    initData() {
      const defaultValue = this.options && this.options['default'] ? this.options['default'] : [];
      return {
        companies: defaultValue,
      };
    },
    gridTemplateColumns() {
      return (this.options && this.options['gridTemplateColumns']) || 'auto auto'
    },
  },
  data() {
    return {
      companies: "",
    };
  },
  created() {
    this.companies = this.initData.companies;
    this.$emit("input", this.companies);
  },
  mounted() {
    if (this.setRef) {
      // filter 모드에서 초기화 버튼 클릭시 검색조건을 초기화 하기 위해서 ref 를 연결해주기 위함
      this.setRef('searchFilterItem', this.$refs.searchFilterItem)
    }
  },
  methods: {
    change(data) {
      this.$emit("input", data);
    },
    onClickFilterRemove () {
      this.companies = [];
      this.$emit("input", this.companies);
    }
  },

}
</script>

<style scoped>

</style>
